import React, { useRef } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { Problem } from './components/Problem';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostSection } from './components/CostSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
export function App() {
  const ctaEndRef = useRef<HTMLDivElement>(null);
  return <div className="min-h-screen w-full bg-cream font-sans text-navy" data-id="element-0" data-mp="2whx8rm2ytac0">
      <Header data-id="element-1" data-mp="28t4l0cwhy8sh" />
      <main data-id="element-2" data-mp="28sl3uyeo7ofi">
        <Hero ctaEndRef={ctaEndRef} data-id="element-3" data-mp="28sbad0uf2z52" />
        <Stats data-id="element-4" data-mp="23vuoyeelqyvo" />
        <Testimonials title="Lo que dicen las maestras que ya lo tienen" variant="first" data-id="element-5" data-mp="23u9uspw79hyc" />
        <Problem data-id="element-6" data-mp="3ijfv1zlojwem" />
        <Tomos data-id="element-7" data-mp="3ihv048vgebg8" />
        <Bonos data-id="element-8" data-mp="3mljat0fdtn5p" />
        <Offer data-id="element-9" data-mp="3ml14tc2x3ukl" />
        <Testimonials title="❤️ Más docentes que ya lo tienen" variant="second" data-id="element-10" data-mp="3mkrgdsxitvh0" />
        <Guarantee data-id="element-11" data-mp="3rdatypw7kqlt" />
        <Faq data-id="element-12" data-mp="3rd1azm9kzjpm" />
        <CostSection data-id="element-13" data-mp="3recctgjguhe3" />
        <FinalCta data-id="element-14" data-mp="5ot150vj28n" />
        <Footer data-id="element-15" data-mp="67yhm9c7y5s" />
      </main>
      <FloatingCta triggerRef={ctaEndRef} data-id="element-16" data-mp="5gfdawxfswe" />
    </div>;
}